import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const Administration_1 = (props: RealEstateDataPageComponentData) => {
  const { title, paragraph, items, backgroundHexa, hidden } = props

  return (
    <section className="tasaciones-administracion a p-y-config">
      <Container fluid>
        <Row>
          <Col lg={2}>
            <p className="section-name">{title}</p>
          </Col>
          <Col lg={10}>
            <h2 className="sub-section text-white">{paragraph}</h2>
          </Col>
          <Col lg={{ span: 10, offset: 2 }}>
            <Row>
              {items?.map(
                ({ paragraph }, index) =>
                  paragraph !== '' && (
                    <Col
                      key={index}
                      lg={4}
                      className="mb-5"
                    >
                      <div
                        className="item d-flex d-lg-block"
                        key={index}
                      >
                        {hidden && (
                          <i
                            className="icon-check mb-4 d-inline-block"
                            style={{
                              border: `1px solid ${backgroundHexa || '#fff'}`,
                              color: backgroundHexa || '#fff',
                              padding: '5px',
                              borderRadius: '50%',
                            }}
                          ></i>
                        )}
                        <p>
                          {paragraph}
                          <br
                            className="d-none d-lg-block"
                            key={index}
                          />
                        </p>
                      </div>
                    </Col>
                  ),
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Administration_1
